// removed by extract-text-webpack-plugin
module.exports = {"footerContainer":"footerContainer__dZp0H","footerInnerContainer":"footerInnerContainer__3sZA_","footerInnerContainerOnNeutralTemplate":"footerInnerContainerOnNeutralTemplate__s5suL","footerLinks":"footerLinks__2lC-w","footerLink":"footerLink__gcAyE","tradeMark":"tradeMark__3HrSj","footerContainerWithBottomNav":"footerContainerWithBottomNav__1_9kZ","footerLinksOnNeutralTemplate":"footerLinksOnNeutralTemplate__1X0ds"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/common/genericFooter/style.css
// module id = 20h8
// module chunks = 380